import { render, staticRenderFns } from "./foldModel.vue?vue&type=template&id=c7c9f526&scoped=true&"
import script from "./foldModel.vue?vue&type=script&lang=js&"
export * from "./foldModel.vue?vue&type=script&lang=js&"
import style0 from "./foldModel.vue?vue&type=style&index=0&id=c7c9f526&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c9f526",
  null
  
)

export default component.exports